document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const swiperElement = document.querySelector('.product-recommendations__list');
    
    if (swiperElement) {
      new Swiper(swiperElement, {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: false, 
        watchSlidesProgress: false,
        watchOverflow: true, 
        resizeObserver: true,
        
        pagination: { 
          el: swiperElement.querySelector('.swiper-pagination'), 
          clickable: true,
        },
        
        observer: true,
        observeParents: true
      });
      console.log('Swiper initialized successfully');
    } else {
      console.warn('Swiper element not found: .product-recommendations__list');
    }
  }, 5000); // 2000ms = 2 second delay
});

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    if (e.target.closest('.collection-custom-filter facet-remove .button--simple')) {
      const facetsMenuButton = document.querySelector('.facets-menu facet-remove .button--simple');
      
      if (facetsMenuButton) {
        facetsMenuButton.click();
        console.log('Triggered facets-menu remove button click');
      }
    }
  });
});

var elems = document.querySelectorAll('.popular-products .popular-products__wrapper');

elems.forEach(function(elem) {
  new Flickity(elem, {
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: true
  });
});
